module.exports = __webpack_public_path__ + "static/media/dekton_894x470.43631ab5.png";